// Keycloak
export const KEYCLOAK_BASE_URL = `${import.meta.env.VITE_KEYCLOAK_BASE_URL}`

export const KEYCLOAK_AUTH_ACCESS_CLIENT_ID = `${import.meta.env.VITE_KEYCLOAK_AUTH_ACCESS_CLIENT_ID}`
export const KEYCLOAK_AUTH_ACCESS_GRANT_TYPE = `${import.meta.env.VITE_KEYCLOAK_AUTH_ACCESS_GRANT_TYPE}`
export const KEYCLOAK_AUTH_ACCESS_REALM = `${import.meta.env.VITE_KEYCLOAK_AUTH_ACCESS_REALM}`

export const KEYCLOAK_AUTH_TOKEN_KEY = "KEYCLOAK_AUTH_TOKEN_KEY"

// Clients Service Endpoints
export const CLIENT_SERVICE_BASE_URL = `${import.meta.env.VITE_CLIENT_SERVICE_BASE_URL}`

// Companies
export const GET_CREATE_COMPANIES_URL = CLIENT_SERVICE_BASE_URL + "companies/"
export const GET_UPDATE_DELETE_COMPANY_URL = CLIENT_SERVICE_BASE_URL + "companies/:id/"
export const GET_ADD_COMPANY_SUBSCRIPTION_URL = CLIENT_SERVICE_BASE_URL + "companies/:id/subscriptions/"
export const COMPANY_INVITATION_REQUEST_URL = CLIENT_SERVICE_BASE_URL + "companies/:id/invite/"
export const GET_COMPANY_ACTIVE_USER_COUNT_URL = CLIENT_SERVICE_BASE_URL + "companies/:id/active_users_count/"
export const GET_COMPANY_ACTIVE_SUBSCRIPTION_URL = CLIENT_SERVICE_BASE_URL + "companies/:id/active-subscription/"
export const COMPANY_STATUS_MANAGEMENT_URL = CLIENT_SERVICE_BASE_URL + "companies/:id/manage-company-status/"
export const GET_ADD_REPRESENTATIVES_URL = GET_UPDATE_DELETE_COMPANY_URL + "representatives/"
export const GET_COMPANY_INVOICES_URL = GET_UPDATE_DELETE_COMPANY_URL + "invoices/"


// Plans
export const GET_ADD_PLANS_URL = CLIENT_SERVICE_BASE_URL + "plans/"
export const GET_UPDATE_DELETE_PLAN_URL = CLIENT_SERVICE_BASE_URL + "plans/:id/"

// Transactions
export const GET_ADD_TRANSACTIONS_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/"
export const GET_TRANSACTION_DETAIL_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/:id/"
export const DOWNLOAD_TRANSACTION_PROOF_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/:id/download-proof/"

//Transactions by Company
export const GET_ADD_TRANSACTIONS_BY_COMPANY_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/by_company/?company_id=:id"

//  TRANSACTIONS CREDIT
export const GET_ADD_TRANSACTIONS_CREDIT_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/create_deposit/"

//  TRANSACTIONS DEBIT
export const GET_ADD_TRANSACTIONS_DEBIT_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/create_debit/"

// Pnding Requests
export const GET_PENDING_REQUESTS_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/pending_requests/"
//Validate Transaction
export const VALIDATE_TRANSACTION_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/:id/validate/"

// Reject Transactions
export const REJECT_TRANSACTION_URL = CLIENT_SERVICE_BASE_URL + "wallets/transactions/:id}/validate/"


//Options
export const GET_ADD_OPTIONS_URL = CLIENT_SERVICE_BASE_URL + "options/"
export const GET_UPDATE_DELETE_OPTION_URL = CLIENT_SERVICE_BASE_URL + "options/:id/"

// Subscriptions
export const GET_ADD_SUBSCRIPTIONS_URL = CLIENT_SERVICE_BASE_URL + "subscriptions/"
export const GET_UPDATE_DELETE_SUBSCRIPTION_URL = CLIENT_SERVICE_BASE_URL + "subscriptions/:id/"
export const GET_SUBSCRIPTIONS_STATISTICS_URL = CLIENT_SERVICE_BASE_URL + "subscriptions/statistics/"
export const SET_SUBSCRIPTION_ADDONS = CLIENT_SERVICE_BASE_URL + "subscriptions/:id/set-addons/"

// Payments
export const GET_ADD_PAYMENTS_URL = CLIENT_SERVICE_BASE_URL + "payments/"
export const GET_UPDATE_DELETE_PAYMENT_URL = CLIENT_SERVICE_BASE_URL + "payments/:id/"

// Code promos
export const GET_ADD_PROMOS_URL = CLIENT_SERVICE_BASE_URL + "promo-codes/"
export const GET_UPDATE_DELETE_PROMO_URL = CLIENT_SERVICE_BASE_URL + "promo-codes/:id/"
export const GET_PROMOS_BY_CODE_URL = GET_ADD_PROMOS_URL + "by-code/"

// Support Members
export const GET_ADD_SUPPORT_MEMBERS_URL = CLIENT_SERVICE_BASE_URL + "support-members/"
export const GET_UPDATE_DELETE_SUPPORT_MEMBERS_URL = CLIENT_SERVICE_BASE_URL + "support-members/:id/"
export const INVITE_SUPPORT_MEMBER_IN_COMPANY_URL = CLIENT_SERVICE_BASE_URL + "support-members/:id/invite-in-company/"

// Representatives
export const GET_REVENUES_URL = CLIENT_SERVICE_BASE_URL + "revenue/"

// Statistics
export const GET_DASHBOARD_STATISTICS_URL = CLIENT_SERVICE_BASE_URL + "statistics/"

// Customers Support
export const GET_ADD_CUSTOMERS_SUPPORT_URL = CLIENT_SERVICE_BASE_URL + "customer-supports/"
export const GET_UPDATE_DELETE_CUSTOMERS_SUPPORT_URL = CLIENT_SERVICE_BASE_URL + "customer-supports/:id/"

// Invoices
export const GET_ADD_INVOICE_URL = CLIENT_SERVICE_BASE_URL + "invoices/"
export const GET_UPDATE_DELETE_INVOICE_URL = GET_ADD_INVOICE_URL + ":id/"